import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const authApi = createApi({
  reducerPath: 'auth',
  baseQuery: createCustomFetchBaseQuery(),
  endpoints: (builder) => ({
    adminLogin: builder.mutation({
      query: (login) => ({
        url: `/admin/login`,
        method: 'POST',
        body: login,
      }),
    }),

    register: builder.mutation({
      query: (register) => ({
        url: `/auth/signup`,
        method: 'POST',
        // headers: { "Content-Type": "multipart/form-data" },
        body: register,
      }),
    }),

    changePassword: builder.mutation({
      query: (data) => ({
        url: `/auth/resetPassword`,
        method: 'PUT',
        body: data,
      }),
    }),

    verifyEmail: builder.mutation({
      query: (data) => ({
        url: `/contractor/validate_otp_password`,
        method: 'POST',
        body: data,
      }),
    }),

    forgotPassword: builder.mutation({
      query: (data) => ({
        url: `/contractor/forgot_password`,
        method: 'POST',
        body: data,
      }),
    }),
    updatePassword: builder.mutation({
      query: (data) => ({
        url: `/contractor/password`,
        method: 'PUT',
        body: data,
      }),
    }),
    resetPassword: builder.mutation({
      query: (data) => ({
        url: `/contractor/reset_password`,
        method: 'POST',
        body: data,
      }),
    }),
    logoutUser: builder.mutation({
      query: ({ role, device_id }) => ({
        url: `${role}/logout`,
        method: 'POST',
        body: { device_id },
      }),
    }),
  }),
});

export const {
  useForgotPasswordMutation,
  useAdminLoginMutation,
  useRegisterMutation,
  useChangePasswordMutation,
  useVerifyEmailMutation,
  useUpdatePasswordMutation,
  useResetPasswordMutation,
  useLogoutUserMutation,
} = authApi;
